import Routes from "routing/Routes";
export const PAGE_NAV_TITLE = "Pipelines";
const bindings = {
  pageNavigation: [
    {
      description: PAGE_NAV_TITLE,
      titleKey: "navigation:system.pipelines",
      children: [
        {
          description: "Manage pipelines",
          titleKey: "pipelines:page_navigation.manage_pipelines",
          path: Routes.SYSTEM.PIPELINES.OVERVIEW,
          exactPathMatch: true
        },
        {
          description: "Manage rules",
          titleKey: "pipelines:page_navigation.manage_rules",
          path: Routes.SYSTEM.PIPELINES.RULES
        },
        {
          description: "Simulator",
          titleKey: "pipelines:page_navigation.simulator",
          path: Routes.SYSTEM.PIPELINES.SIMULATOR
        }
      ]
    }
  ]
};
export default bindings;
